/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free JWT decoder. Paste a JSON Web Token to read its header and payload, with timestamp claims as readable dates. Decode only — no signature verification. Runs in your browser.`)
};

const es_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificador JWT gratuito. Pega un JSON Web Token para leer su encabezado y carga útil, con reclamaciones de marca de tiempo como fechas legibles. Solo decodifica, sin verificación de firma. Se ejecuta en tu navegador.`)
};

const de_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser JWT-Decoder. Fügen Sie ein JSON Web Token ein, um Header und Payload zu lesen — Zeitstempel-Claims werden als lesbare Daten angezeigt. Nur Dekodierung, keine Signaturprüfung. Läuft in Ihrem Browser.`)
};

const nl_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis JWT-decoder. Plak een JSON Web Token in om de header en payload te lezen, met timestamp claims als leesbare datums. Alleen decoderen — geen handtekeningverificatie. Werkt in uw browser.`)
};

const fr_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décodeur JWT gratuit. Collez un jeton JWT pour lire son en-tête et sa charge utile, avec les revendications d'horodatage sous forme de dates lisibles. Décodage uniquement — pas de vérification de signature. S'exécute dans votre navigateur.`)
};

const it_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificatore JWT gratuito. Incolla un JSON Web Token per leggere la sua intestazione e payload, con rivendicazioni di timestamp come date leggibili. Solo decodifica - nessuna verifica della firma. Eseguito nel tuo browser.`)
};

const pt_br2_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decodificador JWT gratuito. Cole um JSON Web Token para ler seu cabeçalho e payload, com reivindicações de timestamp em datas legíveis. Apenas decodificação — sem verificação de assinatura. Funciona no seu navegador.`)
};

const pt_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descodificador JWT gratuito. Cole um JSON Web Token para ler o seu cabeçalho e carga, com reivindicações de marcação de tempo em datas legíveis. Apenas descodificação — sem verificação de assinatura. Funciona no seu navegador.`)
};

const ja_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のJWTデコーダー。JSON Web Tokenを貼り付けてヘッダーとペイロードを読み、タイムスタンプクレームを読みやすい日付で表示します。デコードのみ — シグネチャ検証はありません。ブラウザで実行されます。`)
};

const zh_jw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 JWT 解码器。粘贴一个 JSON Web Token，即可读取其头部和载荷，时间戳声明会以可读日期的形式显示。仅解码——不验证签名。在你的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jw_tool_description", locale)
	if (locale === "en") return en_jw_tool_description(inputs)
	if (locale === "es") return es_jw_tool_description(inputs)
	if (locale === "de") return de_jw_tool_description(inputs)
	if (locale === "nl") return nl_jw_tool_description(inputs)
	if (locale === "fr") return fr_jw_tool_description(inputs)
	if (locale === "it") return it_jw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_jw_tool_description(inputs)
	if (locale === "pt") return pt_jw_tool_description(inputs)
	if (locale === "ja") return ja_jw_tool_description(inputs)
	return zh_jw_tool_description(inputs)
};